import { render, staticRenderFns } from "./indexRatePlans.vue?vue&type=template&id=76722f07&scoped=true&"
import script from "./indexRatePlans.vue?vue&type=script&lang=js&"
export * from "./indexRatePlans.vue?vue&type=script&lang=js&"
import style0 from "./indexRatePlans.vue?vue&type=style&index=0&id=76722f07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76722f07",
  null
  
)

export default component.exports